export const hotelSort = [
  {
    defaultSort: true,
    name: '默认'
  },
  {
    saleNumSort: true,
    name: '销量'
  },
  {
    minPriceSort: true,
    name: '价格'
  }
]

export const studySort = [
  {
    NAME: '默认',
    TRIP: '默认',
    ID: { defaultSort: true }
  },
  {
    NAME: '按销量排序',
    TRIP: '销量',
    ID: { saleNumSort: true }
  },
  {
    NAME: '按价格排序',
    TRIP: '价格',
    ID: { minPriceSort: true }
  }
]
